import React from 'react';
import PropTypes from 'prop-types';
import './PageHeader.css';

export function PageHeader({
  eyebrow,
  title,
  description,
  actions,
  className = '',
}) {
  return (
    <header
      className={['onyx-page-header', className].filter(Boolean).join(' ')}
      data-testid="onyx-page-header"
    >
      <div className="onyx-page-header__text">
        {eyebrow ? <p className="onyx-page-header__eyebrow">{eyebrow}</p> : null}
        {title ? <h1 className="onyx-page-header__title">{title}</h1> : null}
        {description ? (
          <p className="onyx-page-header__description">{description}</p>
        ) : null}
      </div>
      {actions ? (
        <div className="onyx-page-header__actions">{actions}</div>
      ) : null}
    </header>
  );
}

PageHeader.propTypes = {
  eyebrow: PropTypes.node,
  title: PropTypes.node,
  description: PropTypes.node,
  actions: PropTypes.node,
  className: PropTypes.string,
};

export function DesktopRecommended({ className = '' }) {
  return (
    <div
      className={['onyx-desktop-recommended', className].filter(Boolean).join(' ')}
      role="status"
      data-testid="onyx-desktop-recommended"
    >
      This workspace is designed for desktop. You can browse here, but editing works best on a larger screen.
    </div>
  );
}

DesktopRecommended.propTypes = {
  className: PropTypes.string,
};

export default PageHeader;
